module.exports = __webpack_public_path__ + "img/loading.3f79beb3.gif";